import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classes from './Insights.module.scss';

import ConfigureViewHeader from 'components/home/views/configure-view/ConfigureViewHeader';
import TileContainer from '../insights/tiles/TileContainer';
import { getProductData } from 'store/customer/customer-view-actions';
import { CONFIGURE_VIEW } from 'constants/constants';

const Insights = () => {
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) {
      dispatch(getProductData());
    }
  }, []);

  return (
    <div
      className={classes['insights-container']}
      id='Insights'>
      <div className={`${classes['insights-content']}`}>
        <ConfigureViewHeader page={CONFIGURE_VIEW.insights} />
        {allInsightViews?.length > 0 && (
          <TileContainer page={CONFIGURE_VIEW.insights} />
        )}
      </div>
    </div>
  );
};
export default Insights;
